'use client'

import classNames from 'clsx'
import { ComponentPropsWithoutRef, forwardRef } from 'react'

import S from '../Table.module.scss'

export interface TableWrapperProps extends ComponentPropsWithoutRef<'div'> {
  maxWidth?: number | string
}

export const TableWrapper = forwardRef<HTMLDivElement, TableWrapperProps>(
  ({ className, children, maxWidth, style, ...props }, ref) => {
    return (
      <div
        {...props}
        ref={ref}
        className={classNames(S.tableWrapper, className)}
        style={{
          ...style,
          maxWidth: typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth
        }}
      >
        {children}
      </div>
    )
  }
)

TableWrapper.displayName = 'Table.Wrapper'
